import { FC, ReactElement } from "react"
import { useFormikContext } from "formik"

import { formatFiatCurrency } from "../../../util/formatter"
import { InputField } from "../../inputs/InputField"

import { FormValuesType } from "./ModalPromoCode"

export const CacheBalance: FC = (): ReactElement => {
  const { values, touched, errors, handleChange } = useFormikContext<FormValuesType>()
  return (
    <InputField
      id="usd_amount"
      name="usd_amount"
      title="Amount"
      altLabelOne={formatFiatCurrency(values.usd_amount, "$0.00")}
      type="number"
      value={values.usd_amount ?? 0}
      onChange={handleChange}
      invalid={!!(touched.usd_amount && errors.usd_amount)}
      altLabelTwo={touched.usd_amount ? errors.usd_amount : ""}
    />
  )
}
